// data/languages/wolof/categories/salutations.ts

import { CategoryData } from '../../../../types/types';

export const salutations: CategoryData = {
  'Salamalekum (Bonjour)': {
    translation: 'Bonjour',
    translationEn: 'Hello',
    audio: 'Wf-salamalekum',
    illustration: '👋'
  },
  'Ba beneen yoon (Au revoir)': {
    translation: 'Au revoir',
    translationEn: 'Goodbye',
    audio: 'Wf-ba_bennen_yoon',
    illustration: '👋'
  },
  'Na nga def? (Comment allez-vous?)': {
    translation: 'Comment allez-vous?',
    translationEn: 'How are you?',
    audio: 'Wf-na_nga_def',
    illustration: '❓'
  },
  'Maa ngi fi rekk (Je vais bien)': {
    translation: 'Je vais bien',
    translationEn: 'I am doing well',
    audio: 'Wf-maa_ngi_fi_rekk',
    illustration: '😊'
  },
  'Jërejëf (Merci)': {
    translation: 'Merci',
    translationEn: 'Thank you',
    audio: 'Wf-jerejef',
    illustration: '🙏'
  },
  'Amul solo (De rien)': {
    translation: 'De rien',
    translationEn: "You're welcome",
    audio: 'Wf-amul_solo',
    illustration: '😊'
  },
  'Baal ma (S\'il vous plaît / Excusez-moi)': {
    translation: 'S\'il vous plaît / Excusez-moi',
    translationEn: 'Please / Excuse me',
    audio: 'Wf-baal_ma',
    illustration: '🙏'
  },
  'Fanaan ak jamm (Bonne nuit)': {
    translation: 'Bonne nuit',
    translationEn: 'Good night',
    audio: 'Wf-fannanal_ak_jamm',
    illustration: '🌙'
  },
  'Ñam ak jam (Bon appétit)': {
    translation: 'Bon appétit',
    translationEn: 'Enjoy your meal',
    illustration: '🍽️'
  },
  'Naka nga yendoo? (Comment s\'est passée votre journée?)': {
    translation: 'Comment s\'est passée votre journée?',
    translationEn: 'How was your day?',
    audio: 'Wf-naka_nga_yeendo',
    illustration: '❓'
  },
  'Naka tëdd? (Avez-vous bien dormi?)': {
    translation: 'Avez-vous bien dormi?',
    translationEn: 'Did you sleep well?',
    illustration: '😴'
  },
  'Naka waa kër gi? (Comment va la famille?)': {
    translation: 'Comment va la famille?',
    translationEn: 'How is the family?',
    audio: 'Wf-naka_wa_ker_gi',
    illustration: '👨‍👩‍👧‍👦'
  },
  'Jam nga am? (Tout va bien?)': {
    translation: 'Tout va bien?',
    translationEn: 'Is everything okay?',
    illustration: '❓'
  },
  'Mangi ci jàmm (Je suis en paix / Ça va bien)': {
    translation: 'Je suis en paix / Ça va bien',
    translationEn: 'I am at peace / I am doing well',
    audio: 'Wf-mangi_ci_jamm',
    illustration: '😌'
  },
  'Jàmm rekk (Tout va bien)': {
    translation: 'Tout va bien',
    translationEn: 'Everything is fine',
    audio: 'Wf-jamm_rekk',
    illustration: '✅'
  },
  'Waaw (Oui)': {
    translation: 'Oui',
    translationEn: 'Yes',
    audio: 'Wf-waaw',
    illustration: '✅'
  },
  'Déedéet (Non)': {
    translation: 'Non',
    translationEn: 'No',
    audio: 'Wf-deedeet',
    illustration: '❌'
  },
  'Bul tëë (Je vous en prie)': {
    translation: 'Je vous en prie',
    translationEn: "You're welcome",
    illustration: '🤝'
  },
  'Suba tey (Bonjour le matin)': {
    translation: 'Bonjour (le matin)',
    translationEn: 'Good morning',
    audio: 'Wf-suba_tey',
    illustration: '🌅'
  },
  'Ngëndal bu neex (Bon après-midi)': {
    translation: 'Bon après-midi',
    translationEn: 'Good afternoon',
    audio: 'Wf-ngendal_bu_neex',
    illustration: '☀️'
  },
};

export default salutations;
export {};
